import validate from './validate'
import { keyBy } from 'lodash'
import { WITH_LOADING } from '@/store/action-types'
import format from 'date-fns/format'
export { default as policyChangedChecker } from './policyChangedChecker'
export { default as datepickerFormat } from './datepickerFormat'
export { default as dateSelect } from './dateSelect'
export { default as halfFull } from './halfFull'
export { default as esapi } from './esapi'
export default {
  mixins: [validate],

  computed: {
    $isPc () {
      // 判斷ipad、phone、android用戶裝置
      // maxTouchPoints 判斷電腦跟行動裝置的觸控數量
      // let isNotPc = /iPad|iPhone|MacIntel|Linux/.test(navigator.platform)
      //   && navigator.maxTouchPoints > 1

      //允許電腦或平板使用，不給手機(ios、android)使用
      let isNotPc = /iPhone|Linux/.test(navigator.platform)
      const isDev = process.env.NODE_ENV === 'development'
      return !isNotPc || isDev
      // return true
    },
    $isNotPcMsg () {
      return '很抱歉，您目前的裝置不適用此系統，請以PC操作，謝謝!'
    },
    $isSafari () { //判斷safari瀏覽器
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }
  },
  mounted () {
    window.onkeydown = this.keydown
  },

  methods: {
    keydown (e) {
      // 鎖ie backspace back
      if (e.keyCode === 8) {
        var act = true
        if (
          (event.srcElement.tagName.toUpperCase() === 'INPUT' || event.srcElement.tagName.toUpperCase() === 'TEXTAREA') &&
          (event.srcElement.type === 'text' ||
            event.srcElement.type === 'textarea' ||
            event.srcElement.type === 'email' ||
            event.srcElement.type === 'password')
        ) {
          if (event.srcElement.readOnly === true) {
            act = true
          } else {
            act = false
          }
        } else {
          act = true
        }
        if (act) {
          e.preventDefault()
        }
      }
    },
    $yesNo (yn) {
      return yn === 'Y' ? '是' : '否'
    },
    $scrollTo (
      id,
      focus,
      scrollIntoViewOptions = {
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      }
    ) {
      let el = id
      if (this.$bi.isString(id)) {
        el = this.$el.querySelector(`#${id}`)
      }
      el && el.scrollIntoView(scrollIntoViewOptions)
      setTimeout(function () {
        focus && el && el.focus()
      }, 1000)
    },
    $commitAction (payload) {
      return this.$store.dispatch(WITH_LOADING, payload, { root: true })
    },
    $doDecode (list, value, valueKey, textKey) {
      const m = keyBy(list, valueKey)
      let v = m[value] && m[value][textKey]
      return v
    },
    numOnly (num, scale = 0) {
      if (!num) return num
      if (num < 0) return ''
      const r = /\d+\.?\d*/g
      const m = String(num).match(r)
      if (!m) return ''
      num = m.join('')
      num = Number.parseFloat(num)
      if (scale > 0) {
        if (String(num).indexOf('.') > -1) {
          num = Number(num).toFixed(scale)
        }
      } else {
        num = Number.parseInt(num)
      }
      return num
    },
    $toROCDate (d, withTime = false) {
      const pattern = withTime ? 'yyyy/MM/dd HH:mm:ss' : 'yyyy/MM/dd'
      let df = format(new Date(d), pattern)
      let [y, m, dlast] = df.split('/')
      if (parseInt(y) === 9999) {
        return null
      }
      y = y - 1911
      return `${y}/${m}/${dlast}`
    },
    $toADDate (d, withTime = false) {
      const pattern = withTime ? 'yyyy/MM/dd HH:mm:ss' : 'yyyy/MM/dd'
      let df = format(new Date(d), pattern)
      let [y, m, dlast] = df.split('/')
      if (parseInt(y) === 9999) {
        return null
      }
      return `${y}/${m}/${dlast}`
    }
  },
  renderError (h, err) {
    const msg = `error info : ${err.message}`
    return h(
      'v-snackbar',
      { props: { value: true, timeout: 6000, top: true } },
      msg
    )
  },
  filters: {
    $commaFormat: function (value) {
      // 加上千分位符號
      return (
        value &&
        value
          .toString()
          .replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, function (
            all,
            pre,
            groupOf3Digital
          ) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ',$&')
          })
      )
    }
  }
}
